import { CheckableFieldComponent } from "./chunk-UIONNZDK.js";
import { Toggle_default } from "./chunk-KALCZCQ5.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/ToggleField/ToggleField.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { Field, Description, Label } from "@headlessui/react";
import { jsx, jsxs } from "react/jsx-runtime";
var ToggleField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      label,
      description,
      badge,
      secondaryAction,
      validation,
      validationMessage,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "label", "description", "badge", "secondaryAction", "validation", "validationMessage", "className"]);
  return /* @__PURE__ */jsxs(Field, {
    as: CheckableFieldComponent,
    id,
    name,
    label,
    description,
    badge,
    secondaryAction,
    variant: "secondary",
    validation,
    validationMessage,
    className: clsx("pd:toggle-field", className),
    children: [/* @__PURE__ */jsx(Toggle_default, __spreadValues({
      ref,
      screenReaderLabel: label,
      className: "pd:checkable-field__input pd:toggle-field__input"
    }, rest)), /* @__PURE__ */jsxs(Label, {
      className: "pd:checkable-field__wrap pd:toggle-field__wrap",
      children: [/* @__PURE__ */jsx(CheckableFieldComponent.Label, {
        className: "pd:toggle-field__label"
      }), /* @__PURE__ */jsx(Description, {
        as: CheckableFieldComponent.Description,
        className: "pd:toggle-field__description"
      }), /* @__PURE__ */jsx(CheckableFieldComponent.SecondaryAction, {
        className: "pd:toggle-field__secondary-action",
        onClick: e => e.stopPropagation()
      }), /* @__PURE__ */jsx(CheckableFieldComponent.Badge, {
        className: "pd:toggle-field__badge"
      }), /* @__PURE__ */jsx(CheckableFieldComponent.Validation, {
        className: "pd:toggle-field__validation"
      })]
    })]
  });
});
var ToggleField_default = ToggleField;
export { ToggleField_default };